import { safeFilename, type EmailAttachment } from "./eml";

export { AnswerEmailButton } from "./AnswerEmailButton";
export { EmailButton } from "./EmailButton";
export { emailDraftConfig } from "./config";
export { isEmailRequest, planEmails, stripEmailDisclaimer, type EmailPlan } from "./intent";
export {
  answerEmailDocument,
  artifactEmailDocument,
  dashboardEmailDocument,
  sectionPanelId,
} from "./sources";
export type { EmailDraftSource } from "./useEmailDraft";

/** Wraps an exported PDF so it can ride along as the draft's attachment. */
export async function pdfAttachment(blob: Blob, title: string): Promise<EmailAttachment> {
  return {
    filename: safeFilename(title, "pdf"),
    contentType: "application/pdf",
    bytes: new Uint8Array(await blob.arrayBuffer()),
  };
}
